import { render } from "./NavigationBar.vue?vue&type=template&id=2383da25&scoped=true&ts=true"
import script from "./NavigationBar.ts?vue&type=script&lang=ts&external"
export * from "./NavigationBar.ts?vue&type=script&lang=ts&external"

import "./NavigationBar.scss?vue&type=style&index=0&id=2383da25&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2383da25"]])

export default __exports__